import { render, staticRenderFns } from "./GSalesCounter.vue?vue&type=template&id=8b625c2c"
import script from "./GSalesCounter.vue?vue&type=script&lang=js"
export * from "./GSalesCounter.vue?vue&type=script&lang=js"
import style0 from "./GSalesCounter.vue?vue&type=style&index=0&id=8b625c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports